"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const random_1 = __importDefault(require("random"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('c', () => {
    return String.fromCharCode(random_1.default.int(0x4e00, 0x9fff));
});
